import React, { Component } from 'react'
import { Link, Redirect } from 'react-router-dom'
import { Col, Row } from 'reactstrap'
import { ToastContainer } from 'react-toastify'
import HeaderWithMenu from '../components/HeaderWithMenu'
import Footer from '../components/Footer'

class NotFoundPage extends Component {
  state = {
    redirect: false,
  }

  componentDidMount() {
    this.id = setTimeout(() => this.setState({ redirect: true }), 2500)
  }

  componentWillUnmount() {
    clearTimeout(this.id)
  }

  render() {
    return this.state.redirect ? (
      <Redirect to="/" />
    ) : (
      <>
        <HeaderWithMenu />
        <main>
          <Row className="mb-5 align-items-center justify-content-center">
            <Col xs="5" className=" justify-content-center">
              <span className="display-1 d-block">404</span>
              <div className="mb-4 lead">The page was not found.</div>
              <Link to="/">Back to search</Link>
            </Col>
          </Row>
          <ToastContainer />
        </main>
        <Footer />
      </>
    )
  }
}

export default NotFoundPage
